import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  BreadcrumbModule,
  ModalModule,
  DropdownModule,
  LogoModule,
  NavbarModule,
  SidebarModule,
  LoaderModule,
  IconModule,
  TableModule,
  EmptyStateModule,
  StatusModule,
  TooltipModule
} from '@michelin/theme';
import { UploadFotoComponent } from './components/upload-photo.component';
import { BannerComponent } from './components/banner.component';

const modules = [
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  BreadcrumbModule,
  DropdownModule,
  ModalModule,
  SidebarModule,
  NavbarModule,
  LogoModule,
  LoaderModule,
  IconModule,
  TableModule,
  EmptyStateModule,
  UploadFotoComponent,
  BannerComponent,
  StatusModule,
  TooltipModule
];

@NgModule({
  imports: [...modules],
  declarations: [],
  exports: [...modules],
  providers: []
})
export class SharedModule {}
